import clsx from "clsx";
import sanitizedData from "@/core/helpers/sanitizedData";
import { Star3Icon } from "@/shared/icons";

type Props = {
  title: string;
  description: string;
  className?: string;
  isDecor?: boolean;
};

export default function FactionTooltipContent({ title, description, className, isDecor }: Props) {
  return (
    <div
      className={clsx("w-[19.625rem] bg-[#1E1E1E] border border-white/6 rounded-2xl", className)}
    >
      <div className="relative size-full p-4 rounded-2xl overflow-clip">
        <p className="relative z-1 mb-2 text-14 font-bold uppercase leading-none">{title}</p>
        <p
          className="relative z-1 text-13 font-medium text-white/70 leading-[1.125rem]"
          dangerouslySetInnerHTML={sanitizedData(description)}
        />
        {isDecor && (
          <>
            <Star3Icon className="absolute -top-6 -right-6 size-24 text-white/3 -rotate-[18deg]" />
            <Star3Icon className="absolute -bottom-10 left-5 size-24 text-white/3 rotate-[66deg]" />
          </>
        )}
      </div>
    </div>
  );
}
